import React, { useEffect, useState } from "react";
import { Phone, Mail, Star, Shield } from "lucide-react";
import api, { mediaSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Leadership() {
  const { user } = useAuth();
  const [cadre, setCadre] = useState([]);
  const [myRecruiter, setMyRecruiter] = useState(null);

  useEffect(() => {
    api.get("/leadership").then((r) => setCadre(r.data)).catch(() => {});
    if (user?.recruiter) {
      api.get("/recruiters").then((r) => {
        setMyRecruiter((r.data || []).find((x) => x.name === user.recruiter) || { name: user.recruiter });
      }).catch(() => {});
    }
  }, [user?.recruiter]);

  return (
    <div data-testid="leadership-page">
      <div className="eyebrow mb-1" style={{ letterSpacing: "0.16em" }}>Chain of Support</div>
      <h1 className="heading text-4xl mb-6">My Leadership</h1>

      <div className="eyebrow mb-3" style={{ letterSpacing: "0.16em" }}>Your Recruiter</div>
      {myRecruiter ? (
        <div className="rsp-card p-5 flex gap-4 mb-6" data-testid="my-recruiter">
          {myRecruiter.photo_url ? (
            <img src={mediaSrc(myRecruiter.photo_url)} alt={myRecruiter.name} className="w-20 h-20 rounded-xl object-cover border border-[var(--rsp-border)]" />
          ) : (
            <div className="w-20 h-20 rounded-xl bg-[var(--rsp-bg-2)] border border-[var(--rsp-border)] flex items-center justify-center gold font-head text-3xl">{myRecruiter.name?.[0] || "?"}</div>
          )}
          <div className="flex-1">
            <div className="font-head text-2xl uppercase tracking-wide leading-none">{myRecruiter.name}</div>
            {myRecruiter.bio && <p className="text-[var(--rsp-gray)] text-sm mt-2 leading-relaxed">{myRecruiter.bio}</p>}
            <div className="flex flex-wrap gap-3 mt-3">
              {myRecruiter.phone && <a href={`tel:${myRecruiter.phone}`} className="pill" data-testid="recruiter-call"><Phone size={14} />{myRecruiter.phone}</a>}
              {(myRecruiter.secondary_email || myRecruiter.email) && <a href={`mailto:${myRecruiter.secondary_email || myRecruiter.email}`} className="pill" data-testid="recruiter-email"><Mail size={14} />Email</a>}
            </div>
          </div>
        </div>
      ) : (
        <div className="rsp-card p-6 text-center text-[var(--rsp-muted)] mb-6">
          <Star className="mx-auto mb-2 opacity-50" /> No recruiter assigned yet. An admin will connect you soon.
        </div>
      )}

      <div className="eyebrow mb-3" style={{ letterSpacing: "0.16em" }}>Cadre &amp; Command</div>
      <div className="space-y-3">
        {cadre.map((c, i) => (
          <div key={`${c.title}-${c.name}`} className="rsp-card p-4 flex items-center gap-3" data-testid={`cadre-${i}`}>
            {c.photo_url ? (
              <img src={mediaSrc(c.photo_url)} alt={c.name} className="w-11 h-11 rounded-lg object-cover" />
            ) : (
              <div className="w-11 h-11 rounded-lg bg-[var(--rsp-bg-2)] border border-[var(--rsp-border)] flex items-center justify-center"><Shield className="gold" size={20} /></div>
            )}
            <div className="flex-1">
              <div className="font-semibold">{c.name}</div>
              <div className="text-[var(--rsp-gray)] text-sm">{c.title}</div>
            </div>
            {c.can_message && c.email && <a href={`mailto:${c.email}`} className="pill" data-testid={`cadre-msg-${i}`}><Mail size={14} /></a>}
          </div>
        ))}
        {cadre.length === 0 && <p className="text-[var(--rsp-muted)]">No cadre listed.</p>}
      </div>
    </div>
  );
}
